module.exports = __webpack_public_path__ + "39590b77941344fc7d67294305e3fd94.svg";